module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: _vm.contStyle
  }, [_c('div', {
    staticClass: "cont169"
  }, [(_vm.previewType == 'image') ? _c('div', {
    staticClass: "imageCont"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.linkToDetail
    }
  }, [_c('intersect', {
    on: {
      "enter": function($event) {
        _vm.msg = 'Intersected'
      },
      "leave": function($event) {
        _vm.msg = 'Not intersected'
      }
    }
  }, [_c('img', {
    staticClass: "youtubeThumb",
    attrs: {
      "src": _vm.youtubeThumb,
      "alt": _vm.imgYTalt
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.previewType == 'video') ? _c('div', [(_vm.online) ? _c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": _vm.youtubeEmbedIframeUrl,
      "frameborder": "0",
      "allowfullscreen": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.online) ? _c('div', {
    staticClass: "imageCont"
  }, [_c('img', {
    staticClass: "youtubeThumb",
    attrs: {
      "src": _vm.youtubeThumb,
      "alt": _vm.imgYTalt
    }
  })]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.vote) ? _c('div', {
    staticClass: "voteCont"
  }, [(_vm.online) ? _c('div', [(_vm.previewType == 'video') ? _c('span', {
    attrs: {
      "aria-label": _vm.votesLabel
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.votes) + "\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "voteUp",
    attrs: {
      "aria-label": "vota a favore"
    },
    on: {
      "click": _vm.voteUp
    }
  }, [_c('i', {
    staticClass: "gdr-icon gdr-icon-thumbs-up"
  })]), _vm._v(" "), _c('button', {
    staticClass: "voteDown",
    attrs: {
      "aria-label": "vota contro"
    },
    on: {
      "click": _vm.voteDown
    }
  }, [_c('i', {
    staticClass: "gdr-icon gdr-icon-thumbs-down"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.online) ? _c('div', [_vm._v("\n\t\t\tSei offline, non puoi vedere il video o votare\n\t\t")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b9b8a2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/videoPlayer.vue
// module id = 202
// module chunks = 8 9